import { RadioGroupField, RadioGroupFieldProps } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

const options = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM_PAPANICOLAU, label: 'Sim, papanicolau' },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO, label: 'Não' },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO_INFORMADO, label: 'Não informado' },
]

export function ExamePreventivoRadioField(
  props: Readonly<Omit<RadioGroupFieldProps<RastreioCancerPerguntaOpcaoEnum>, 'options'>>
) {
  return <RadioGroupField label='Fez exame preventivo anteriormente?' {...props} options={options} />
}
